.timeline {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 0.5rem;
}

.item {
  position: relative;
  padding-left: 3rem;
}

/* The vertical rail, drawn per-item so it stops cleanly at the last entry. */
.item::before {
  content: '';
  position: absolute;
  left: 1.09rem;
  top: 0;
  bottom: 0;
  width: 1px;
  background: var(--border);
}

.item:first-child::before {
  top: 1.6rem;
}

.item:last-child::before {
  bottom: auto;
  height: 1.6rem;
}

.marker {
  position: absolute;
  left: 0;
  top: 0.85rem;
  z-index: 1;
  display: grid;
  place-items: center;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 50%;
  border: 1px solid var(--border);
  background: var(--bg-elev);
  color: var(--text-faint);
}

.card {
  padding: 0.35rem 0 1.75rem;
}

.item[data-current] .marker {
  color: var(--accent);
  border-color: color-mix(in srgb, var(--accent) 45%, var(--border));
  box-shadow: 0 0 0 4px var(--accent-quiet);
}

.period {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-family: var(--font-mono);
  font-size: 0.74rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-faint);
}

.badge {
  padding: 0.15rem 0.5rem;
  border-radius: var(--radius-pill);
  background: var(--accent-quiet);
  color: var(--accent);
  font-size: 0.66rem;
  font-weight: 600;
  letter-spacing: 0.06em;
}

.role {
  margin-top: 0.4rem;
  font-size: var(--step-1);
  font-weight: 600;
  letter-spacing: -0.01em;
}

.org {
  margin-top: 0.15rem;
  color: var(--accent);
  font-size: var(--step--1);
  font-weight: 500;
}

.summary,
.highlights {
  margin-top: 0.85rem;
  color: var(--text-dim);
  font-size: var(--step--1);
  line-height: 1.7;
}

.highlights {
  list-style: none;
  padding: 0;
  display: grid;
  gap: 0.4rem;
  max-width: 60ch;
}

.highlights li {
  position: relative;
  padding-left: 1.1rem;
}

.highlights li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0.62em;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--border-strong);
}

/* Give the marker a little more breathing room on narrow screens. */
@media (max-width: 30rem) {
  .item {
    padding-left: 2.5rem;
  }

  .item::before {
    left: 0.92rem;
  }

  .marker {
    width: 1.9rem;
    height: 1.9rem;
  }
}
